import { SoftwrkApi } from "configs/StoreQueryConfig";

const BASE_URL = "/Auth";

console.log(BASE_URL);

export const SignupApi = SoftwrkApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (config) => ({
        url: `${BASE_URL}/Sign-In`,
        method: "POST",
        ...config,
      }),
    }),
    verifyOtp: builder.mutation({
      query: ({ code, email }) => ({
        url: `/twofa-verify`,
        method: "POST",
        body: { code, email },
      }),
    }),
  }),
});

export default SignupApi;
